import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MessagesSquare, Search } from "lucide-react";
import api, { apiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export default function Submissions() {
  const [subs, setSubs] = useState(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/business/submissions").then(({ data }) => setSubs(data)).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div data-testid="submissions-page">
      <h1 className="text-3xl font-black">Submissions</h1>
      <p className="text-sm text-neutral-500 mt-1">Every form submission opens a conversation automatically.</p>

      <div className="mt-6 relative max-w-sm">
        <Search className="h-4 w-4 text-neutral-500 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search customer, email, form…"
          className="pl-9"
          data-testid="submissions-search-input"
        />
      </div>

      <div className="mt-8 bg-white border border-[#E5E5E5] rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E5E5E5] text-left text-xs uppercase tracking-widest text-neutral-400">
              <th className="px-5 py-3">Customer</th>
              <th className="px-5 py-3">Form</th>
              <th className="px-5 py-3">Files</th>
              <th className="px-5 py-3">Date</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E5E5]">
            {!subs ? (
              <tr><td className="px-5 py-6 text-neutral-400" colSpan={5}>Loading…</td></tr>
            ) : subs.length === 0 ? (
              <tr><td className="px-5 py-6 text-neutral-400" colSpan={5} data-testid="submissions-empty">No submissions yet.</td></tr>
            ) : (
              subs.filter((s) => {
                if (!query.trim()) return true;
                const q = query.toLowerCase();
                return (s.customer_name || "").toLowerCase().includes(q) || (s.customer_email || "").toLowerCase().includes(q) || (s.form_title || "").toLowerCase().includes(q);
              }).map((s) => (
                <tr key={s.id} data-testid={`submission-row-${s.id}`}>
                  <td className="px-5 py-3.5">
                    <div className="font-medium">{s.customer_name || "—"}</div>
                    <div className="text-xs text-neutral-400">{s.customer_email}</div>
                  </td>
                  <td className="px-5 py-3.5">{s.form_title}</td>
                  <td className="px-5 py-3.5">{s.files?.length || 0}</td>
                  <td className="px-5 py-3.5 text-neutral-500">{new Date(s.created_at).toLocaleString()}</td>
                  <td className="px-5 py-3.5 text-right">
                    {s.conversation_id && (
                      <Link to={`/dashboard/conversations/${s.conversation_id}`} data-testid={`submission-thread-${s.id}`}>
                        <Button variant="outline" size="sm" className="rounded-full">
                          <MessagesSquare className="h-3.5 w-3.5 mr-1" /> Thread
                        </Button>
                      </Link>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
